const type = 'advanced'
const path = '/advance/react-node/advanced-integration/src/components/'
const name = 'PaymentForm.js'

export { type, path, name }
